import React from 'react'
//import Container from 'react-bootstrap/Container';
////import Row from 'react-bootstrap/Row';
///*import vigenereImg from '../../vigenere.png'*/
//import vigenereGif from '../../vigenere.gif'
///*import faImg from '../../fa.png'*/
//import faGif from '../../fa.gif'
///*import colorConverterImg from '../../colorconverter.png'*/
//import colorConverterGif from '../../colorconverter.gif'
import { LinkButton } from './LinkButton';
/*import { HeadingBlock } from '../shared/HeadingBlock';*/
//import Col from 'react-bootstrap/Col';

export const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <>
            <div className="page-footer__inner">

                <p className="page-footer__text">Found a bug or got a question about the site? Drop me an email at <a className="link" href="mailto: ciphercentreweb@gmail.com">CipherCentreWeb@gmail.com</a></p>

                <LinkButton link="mailto: ciphercentreweb@gmail.com" bg="secondary" icon="fa-paper-plane" text='Send me a message' />

                <p className="page-footer__text">If you wish to support the site you can do so via the 'buy me a coffee' button.</p>

                <LinkButton link="https://www.buymeacoffee.com/kamilko" bg="primary" isBmc={true} text='Buy me a coffee' />
            </div>
            <div className="footer-bar">
                <div className="footer-bar__inner">
                    <p>&copy; <span>{currentYear}</span> CipherCentre.com. All rights reserved.</p>
                </div>

            </div>

        </>


    )
}
